<template>
    <p :id="'grp_' + id" :class="fixedSize === true ? 'tan-group' : 'tan-group tan-group-flex'">
        <input :id="id" :name="id" type="hidden" v-bind:value="value"/>

        <input :id="id+i" :aria-label="ariaLabelTanType + ' - ' + $t('aria.common.position') + ' ' + i" :key="id+i"
               :aria-invalid="invalid"
               aria-required="true"
               :aria-describedby="ariaErrorElementId"
               v-for="i in 6" :idx="i"
               v-bind:value="code[i-1]"
               @input="onInput"
               @click="onClick"
               @focus="$event.target.select()"
               @keyup.delete.stop="deleteItem"
               class="tan-field" placeholder="-"
               pattern="[0-9]{1}" inputmode="numeric" type="text" minlength="1"
               autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false">
    </p>
</template>

<script>
import { mixin } from '../js/ciam-mixin.js'

const isDigit = /^[0-9]{1}$/
const isOneTimeCode = /^[0-9]{6}$/

export default {
  mixins: [mixin],
  props: {
    id: String,
    value: {
      type: String,
      default: ''
    },
    fixedSize: {
      type: Boolean,
      default: true
    },
    ariaLabelTanType: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    ariaErrorElementId: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data: function () {
    return {
      code: [null, null, null, null, null, null]

    }
  },
  methods: {
    reset: function () {
      this.code = [null, null, null, null, null, null]
      this.$emit('change', null)
    },
    setItem (idx, key) {
      console.debug(`setItem(${idx},${key})`)

      const i = parseInt(idx) - 1
      this.code[i] = key

      this.updateComponentValue()

      const currentElement = $('#' + this.id + (i + 1))

      if (i < 5) {
        currentElement.blur()
        // focus on the next input
        $('#' + this.id + (i + 2)).focus()
      } else {
        if (this.isValid()) {
          currentElement.blur()
          this.$emit('focusout')

          // Required for MS Edge for the last element to lose the focus:
          currentElement.hide()
          currentElement.show()
        } else {
          // focus on the first not valid input
          for (let i = 0; i < 6; i++) {
            if (!this.code[i]) {
              $('#' + this.id + (i + 1)).focus()
            }
          }
        }
      }
    },
    deleteItem (e) {
      const idx = e.target.getAttribute('idx')
      const i = parseInt(idx) - 1
      if (this.code[i]) {
        this.code[i] = null
      }
      if (i > 0) {
        this.code[i - 1] = null
        const currentElement = $('#' + this.id + (i + 1))
        currentElement.blur()

        $('#' + this.id + i).focus() // focus on previous
      }
      this.updateComponentValue()
    },
    updateComponentValue: function () {
      let x = ''

      for (let i = 0; i < 6; i++) {
        x += this.code[i] ? this.code[i] : '-'
      }
      console.debug('emit(changeTo:' + x + ')')
      this.$emit('change', x)
    },
    focus: function () {
      const firstInputField = $('#' + this.id + 1)
      firstInputField.focus()
    },
    isValid: function () {
      let code = ''
      for (let i = 0; i < 6; i++) {
        code += this.code[i] ? this.code[i] : '-'
      }
      return isOneTimeCode.test(code)
    },
    onInput: function (e) {
      console.debug('onInput: event.data=' + e.data + ', event.target.value=' + e.target.value)

      let inputValue = e.data ? e.data : e.target.value
      inputValue = inputValue ? inputValue.trim() : null

      const index = e.target.getAttribute('idx')

      if (isDigit.test(inputValue)) {
        this.setItem(index, inputValue)
      } else if (isOneTimeCode.test(inputValue)) {
        this.reset()
        const allTanFields = Array.from(document.querySelectorAll('input.tan-field'))
        allTanFields.forEach((fieldToUpdate, indexToUpdate) => {
          fieldToUpdate.value = inputValue[indexToUpdate]
          this.setItem(indexToUpdate + 1, fieldToUpdate.value)
        })
      } else {
        $('#' + this.id + index).val(null)
        this.updateComponentValue()
      }
    },
    onClick: function (e) {
      const i = parseInt(e.target.getAttribute('idx')) - 1
      if (this.code[i] !== null) {
        this.code[i] = null
        this.updateComponentValue()
      }
    }
  },
  mounted () {
    // Activate auto completion on the first input.
    // Auto completion will not work properly in Safari on other inputs because
    // Safari inserts first digit into the selected element.
    const firstInputField = $('#' + this.id + 1)
    firstInputField.attr('autocomplete', 'one-time-code')

    this.focus()
  }
}
</script>

<style scoped>

    .tan-field {
        margin: 0 4px !important;
        padding: 0 1px !important;
        height: 50px !important;
        width: 35px !important;
        text-align: center !important;
        vertical-align: top;
        font-family: DaimlerCAC-Regular, serif !important;
        font-size: 26px !important;
        line-height: 26px !important;
        border-radius: 5px !important;
        -moz-appearance: textfield !important;
    }

    .tan-field:focus,
    .tan-field:active{
        color: rgba(0, 0, 0, .8) !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;

    }

    /* Chrome, Safari, Edge, Opera */
    input[type="text"]::-webkit-outer-spin-button,
    input[type="text"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .tan-group-flex {
        width: 100%;
        display: flex;
        position: relative;
    }

    /* Prevent style changes after auto-completion */
    .tan-group > .tan-field:-webkit-autofill,
    .tan-group > .tan-field:-webkit-autofill:hover,
    .tan-group > .tan-field:-webkit-autofill:focus {
        -webkit-text-fill-color: inherit !important;
        -webkit-box-shadow: 0 0 0 1000px #f4f4f4 inset !important;
        transition: background-color 5000s ease-in-out 0s;
        border-color: #BDBDBD !important;
    }

    .field.error .tan-group .tan-field::placeholder {
        color: #9f3a38 !important;
    }

    .field.error .tan-group .tan-field:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #9f3a38 !important;
    }

    .field.error .tan-group .tan-field::-ms-input-placeholder { /* Microsoft Edge */
        color: #9f3a38 !important;
    }

</style>
